import { useLayoutEffect } from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useGiroPaymentManager } from 'hooks/useGiroPaymentManager';
import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';

export const useGiroPaymentManagerDataProcess = (giroPaymentId: number) => {
  const dispatch = useAppDispatcher();

  const { injectPromise } = useAsyncBoundary();

  const { getGiroPaymentManagerData } = useServices();

  const { dataInvalidated } = useGiroPaymentManager();

  useLayoutEffect(() => {
    if (dataInvalidated) {
      const promise = getGiroPaymentManagerData(giroPaymentId).then((data) => {
        dispatch({
          name: 'GiroPaymentManager__DataRecieved',
          data,
        });
      });

      injectPromise(promise);
    }
  }, [
    dataInvalidated,
    dispatch,
    getGiroPaymentManagerData,
    giroPaymentId,
    injectPromise,
  ]);
};
